<template>
  <div>
    <stock :searchObj="searchObj" :stockTypeObj="stockTypeObj" ref="stock" @postListData="postListData">
      <template v-slot:searchDiv>
        <div class="secondSearchLine">
          <el-date-picker v-model="searchObj.date" value-format="yyyy-MM-dd" style="width:1.5rem" size="mini" type="date" placeholder="选择日期"></el-date-picker>
        </div>
      </template>
      <template v-slot:contentDiv>
        <div v-for="(item,index) in dataList" :key="index">
          <custom :item="item" :chenckBudgteObj="$refs.stock.budget" :keyStr="keyStr" class="contentDiv"></custom>
        </div>
      </template>
    </stock>
  </div>
</template>

<script>
import Stock from './stock.vue'
import Api from '@/components/Api/index.js'
export default {
  components:{Stock},
  data(){
    return{
      searchObj:{
        cityId:null,
        cityName:null,
        cityNameCn:null,
        cityNameEn:null,
        countryId:null,
        date:[],
        star:null,
        location:null,
        searchHotelPrice:null,
        keyword:null,
        productType:0,
        state:10,
      },
      dataList:[],
      keyStr:'',
    }
  },
  props:{
    stockTypeObj:{
      type:Object,
      default:()=>{return {}}
    },
    checkState:{
      type:Number,
      default:0,
    }
  },
  methods:{
    postListData(type){
      if(this.checkState===10){
        if(type=='empty'){
          this.dataList =[]
          this.keyStr=''
        }
        this.searchObj.startDate = this.searchObj.date;
        this.searchObj.endDate = this.searchObj.date;
        this.searchObj.key = this.keyStr;
        if(!this.$refs.stock.isMore){
          new Api('resource').rightStockList({page:this.$refs.stock.page,size:10,q:this.searchObj}).then(res => {
            if (res.status == 200) {
              if(res.data.length<10) this.$refs.stock.isMore = true;
              this.$refs.stock.getDateList(res.data)
              res.data.forEach(element => {
                this.dataList.push(element)
              });
              this.keyStr = res.key
            }else{
              this.$message({type:"error",message:res.statusText})
            }
          })
        }
      }
    },
  }
}
</script>

<style>

</style>